export type ChatAttachment = { url: string; name: string };
export type ChatAttachmentScope = {
  activeProjectId: number | null;
  folderProjectId: number | null;
  chatAttachments: ChatAttachment[];
  chatAttachmentDrafts: Record<string, ChatAttachment[]>;
};

export function chatAttachmentScope(state: Pick<ChatAttachmentScope, 'activeProjectId' | 'folderProjectId'>): string {
  if (state.activeProjectId != null) return `task:${state.activeProjectId}`;
  return state.folderProjectId != null ? `folder:${state.folderProjectId}` : 'home';
}

/** Synchronize the visible composer list and in-memory drafts after any store update. */
export function scopedChatAttachmentPatch(current: ChatAttachmentScope, previous: ChatAttachmentScope): Partial<Pick<ChatAttachmentScope, 'chatAttachments' | 'chatAttachmentDrafts'>> | null {
  const oldScope = chatAttachmentScope(previous);
  const newScope = chatAttachmentScope(current);
  if (oldScope !== newScope) {
    const drafts = { ...current.chatAttachmentDrafts, [oldScope]: previous.chatAttachments };
    const destination = drafts[newScope] ?? [];
    drafts[newScope] = destination;
    return { chatAttachmentDrafts: drafts, chatAttachments: destination };
  }
  if (current.chatAttachments !== previous.chatAttachments && current.chatAttachmentDrafts[newScope] !== current.chatAttachments) {
    return { chatAttachmentDrafts: { ...current.chatAttachmentDrafts, [newScope]: current.chatAttachments } };
  }
  return null;
}

/** A completed upload belongs to the composer where it started, including after navigation. */
export function appendUploadedChatAttachment(current: ChatAttachmentScope, scope: string, attachment: ChatAttachment): Partial<ChatAttachmentScope> {
  if (chatAttachmentScope(current) === scope) return {chatAttachments: [...current.chatAttachments, attachment]};
  return {chatAttachmentDrafts: {...current.chatAttachmentDrafts, [scope]: [...(current.chatAttachmentDrafts[scope] ?? []), attachment]}};
}
